module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-home-reviews"
  }, [_c('div', {
    staticClass: "custom-home-reviews__container"
  }, [_c('div', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypointTitle,
        options: _vm.intersectionTitleOptions
      }),
      expression: "{ active: true, callback: onWaypointTitle, options: intersectionTitleOptions }"
    }],
    staticClass: "custom-home-reviews__title",
    class: {
      "custom-home-reviews__title--active": _vm.fadeTitle
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  })]), _c('div', {
    staticClass: "custom-home-reviews__reviews-container"
  }, [_c('swiper', {
    staticClass: "custom-home-reviews__slider",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.props.slides), function(slide, i) {
    return _c('swiperSlide', {
      key: i,
      staticClass: "custom-home-reviews__slide"
    }, [_c('div', {
      staticClass: "custom-home-reviews__image",
      style: ("background-image: url(" + slide.image + ");")
    }, [_c('div', {
      staticClass: "custom-home-reviews__testimonial",
      class: {
        "custom-home-reviews__testimonial--active": _vm.swiping
      }
    }, [_c('div', {
      staticClass: "custom-home-reviews__testimonial--text",
      domProps: {
        "innerHTML": _vm._s(slide.testimonial)
      }
    }), _c('div', {
      staticClass: "custom-home-reviews__testimonial--author",
      domProps: {
        "innerHTML": _vm._s(slide.author)
      }
    })])])])
  }), _c('div', {
    staticClass: "custom-home-reviews__prev-arrow",
    class: {
      "custom-home-reviews__prev-arrow--active": _vm.swiping
    },
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('Icon', {
    attrs: {
      "name": "Arrow"
    }
  })], 1), _c('div', {
    staticClass: "custom-home-reviews__next-arrow",
    class: {
      "custom-home-reviews__next-arrow--active": _vm.swiping
    },
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('Icon', {
    attrs: {
      "name": "Arrow"
    }
  })], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c0df158","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-reviews/custom-home-reviews.pug
// module id = 569
// module chunks = 1